import React, { useState } from 'react';

const styles = {
  base: {
    display: 'inline-flex', alignItems: 'center', gap: 4,
    padding: '3px 10px', borderRadius: 999, fontSize: 12, fontWeight: 600,
    whiteSpace: 'nowrap',
  },
};

const variants = {
  violet: { background: 'var(--violet-pale)', color: 'var(--violet)' },
  yellow: { background: 'var(--yellow-pale)', color: '#B45309' },
  green:  { background: '#DCFCE7', color: '#166534' },
  red:    { background: '#FEE2E2', color: '#991B1B' },
  blue:   { background: '#DBEAFE', color: '#1E40AF' },
  pink:   { background: '#FCE7F3', color: '#9D174D' },
  gray:   { background: '#F3F4F6', color: '#374151' },
  orange: { background: '#FEF3C7', color: '#92400E' },
};

export default function Badge({ children, variant = 'gray', icon, dot }) {
  return (
    <span style={{ ...styles.base, ...variants[variant] }}>
      {dot && <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'currentColor' }} />}
      {icon && <span>{icon}</span>}
      {children}
    </span>
  );
}

// MemoryBadge: badge seul si pas de text, sinon affiche le texte tronqué + "Voir plus"
export function MemoryBadge({ text, inline = false }) {
  const [expanded, setExpanded] = useState(false);

  // Badge compact (dans les tables, etc.)
  if (!text || !inline) {
    return (
      <span style={{
        ...styles.base,
        background: 'linear-gradient(135deg, #FFF8DC, #FFF3B0)',
        color: '#B45309',
        border: '1px solid #FDE68A',
      }}>
        💡 Mémoire
      </span>
    );
  }

  // Inline avec texte expandable
  const LIMIT = 90;
  const isLong = text.length > LIMIT;
  const displayed = isLong && !expanded ? text.slice(0, LIMIT) + '…' : text;

  return (
    <div style={{
      background: 'linear-gradient(135deg, #FFFBEB, #FEF3C7)',
      border: '1px solid #FDE68A',
      borderRadius: 10,
      padding: '8px 12px',
      fontSize: 13,
      color: '#78350F',
      marginTop: 4,
    }}>
      <span style={{ fontWeight: 700, marginRight: 6 }}>💡</span>
      {displayed}
      {isLong && (
        <button
          onClick={(e) => { e.stopPropagation(); setExpanded(v => !v); }}
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#B45309', fontWeight: 700, fontSize: 12,
            marginLeft: 6, padding: 0, textDecoration: 'underline',
          }}
        >
          {expanded ? 'Voir moins' : 'Voir plus'}
        </button>
      )}
    </div>
  );
}

export function ScoreBadge({ score, size = 'md' }) {
  const color = score >= 80 ? '#10B981' : score >= 60 ? '#F59E0B' : score >= 40 ? '#5A35FF' : '#EF4444';
  const bg = score >= 80 ? '#DCFCE7' : score >= 60 ? '#FEF3C7' : score >= 40 ? '#EDE9FF' : '#FEE2E2';
  const s = size === 'sm' ? { fontSize: 11, padding: '2px 8px' } : {};
  return (
    <span style={{ ...styles.base, ...s, background: bg, color }}>
      {score}/100
    </span>
  );
}

export function PlanBadge({ plan }) {
  const map = {
    starter: { label: 'Starter', ...variants.gray },
    pro: { label: 'Pro', ...variants.violet },
    premium: { label: 'Premium', background: 'linear-gradient(135deg, #FFC400, #FFE07A)', color: '#92400E' },
  };
  const v = map[plan] || map.starter;
  return <span style={{ ...styles.base, background: v.background, color: v.color }}>✦ {v.label}</span>;
}
